import React from "react";

class AddProductList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            error: false,
            message: "",
            nameVal: "",
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.addLists = this.addLists.bind(this);
    }

    handleNameChange(e) {
        this.setState({nameVal: e.target.value});
    }

    addLists(event) {
        event.preventDefault();
        this.setState({loading: true});
        fetch("/api/authenticated/productlist/create?name="+this.state.nameVal)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log(result);
                    if (result.success) {
                        this.setState({
                            loading: false,
                            error: false,
                        });
                        this.setState({nameVal:""});
                        this.props.getLists();
                    } else {
                        this.setState({
                            loading: false,
                            error: true,
                            message: result.error
                        });
                    }
                },
                (error) => {
                    this.setState({
                        productsaves: [],
                        loading: false,
                        error: true
                    });
                }
            )
    }

    render() {
        return (
            <div className="container box">
                <form onSubmit={this.addLists}>
                    <div class="field">
                        <div class="control">
                            <label class="label">List Name</label>
                            <input class="input" name="listname" value={this.state.nameVal} onChange={this.handleNameChange} type="text"/>
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <button class="button is-link">Create</button>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

export default AddProductList;